const pages = {
  home: {
    hero: {
      subtitle: "戦略的エネルギー調達コンサルティング",
      title: "原油・LNG調達の",
      titleHighlight: "エキスパートソリューション",
      description: "Medigreen LLCは、原油・LNG調達の専門アドバイザリーサービスを提供しています。豊富な市場専門知識とグローバルネットワークを組み合わせ、エネルギー購入者に最適な成果をもたらします。",
      ctaPrimary: "サービスを見る",
      ctaSecondary: "無料相談",
    },
    services: {
      sectionTitle: "サービス",
      title: "トータルソリューション",
      titleHighlight: "for エネルギー調達",
      description: "市場インテリジェンスから契約実行まで、Medigreenはエネルギー調達戦略を最適化するためのフルスペクトラムのアドバイザリーサービスを提供します。",
      cta: "すべてのサービスを見る",
      items: {
        crudeOil: {
          title: "原油調達アドバイザリー",
          desc: "サプライヤー選定や市場分析から契約交渉・物流調整まで、原油調達のエンドツーエンドアドバイザリーを提供します。",
        },
        lng: {
          title: "LNG調達戦略",
          desc: "長期契約の構築からスポット市場の最適化、価格リスク管理まで、包括的なLNG調達サポートを提供します。",
        },
        market: {
          title: "市場分析・予測",
          desc: "独自のデータ駆動型分析でグローバルエネルギー市場、価格動向、需給ダイナミクスを把握し、調達判断をサポートします。",
        },
        contract: {
          title: "契約交渉サポート",
          desc: "複雑なエネルギー契約交渉のエキスパートガイダンス。有利な条件、リスク軽減、規制対応を確保します。",
        },
      },
    },
    about: {
      sectionTitle: "Medigreen LLCについて",
      title: "信頼できるパートナー",
      titleHighlight: "in エネルギー調達",
      description1: "Medigreen LLCは、原油・LNG調達アドバイザリーに特化したコンサルティングファームです。豊富な市場知識と厳密な分析能力を組み合わせ、エネルギー購入者が最適な調達成果を達成できるようサポートします。",
      description2: "国際エネルギー市場、サプライチェーン管理、契約法において数十年の経験を持つ熟練プロフェッショナルが、調達交渉における決定的な競争優位性を提供します。",
      cta: "詳細を見る",
      badge: {
        label: "グローバルネットワーク",
        value: "40+",
        sublabel: "国・地域",
      },
      strengths: {
        global: {
          title: "グローバルネットワーク",
          desc: "中東、東南アジア、オーストラリア、アメリカ大陸のサプライヤー・取引先へのアクセス。",
        },
        risk: {
          title: "リスク管理",
          desc: "お客様のビジネスニーズに合わせた包括的な価格リスク・供給セキュリティ戦略。",
        },
        team: {
          title: "エキスパートチーム",
          desc: "国際エネルギー取引・調達において20年以上の実務経験を持つコンサルタント。",
        },
      },
    },
    stats: {
      years: "業界経験年数",
      deals: "アドバイスした調達案件",
      clients: "グローバルエネルギークライアント",
      value: "調達総額（米ドル）",
    },
    cta: {
      badge: "お問い合わせ",
      title: "解決をご支援",
      titleHighlight: "Your エネルギー課題の",
      heading: "エネルギー調達の最適化をご検討ですか？",
      description: "変動の激しい原油市場のナビゲーションから長期LNG契約の構築まで、Medigreenのエキスパートがお手伝いします。初回コンサルテーションは無料です。",
      benefits: [
        "無料初回コンサルテーション",
        "カスタマイズされた調達戦略",
        "グローバルサプライヤーネットワークへのアクセス",
        "継続的な市場インテリジェンスサポート",
      ],
      button: "無料コンサルテーションを予約",
    },
    news: {
      sectionTitle: "最新ニュース",
      title: "市場インサイト・アップデート",
      cta: "すべてのニュースを見る",
    },
  },
  services: {
    hero: {
      subtitle: "サービス内容",
      title: "サービス",
      description: "原油・LNG市場で最適な成果を達成するための包括的エネルギー調達アドバイザリーサービス。",
    },
    items: {
      crudeOil: {
        title: "原油調達アドバイザリー",
        desc: "サプライヤー選定、市場分析、価格ベンチマーク、契約交渉をカバーする包括的な原油調達アドバイザリーサービスを提供します。中東、西アフリカ、南北アメリカの生産者との深い関係を活用し、最適な供給条件を確保します。",
        features: [
          "サプライヤー選定・適格性評価",
          "価格ベンチマーク・市場分析",
          "契約構築・交渉",
          "物流・輸送調整",
          "品質検査サポート",
        ],
      },
      lng: {
        title: "LNG調達戦略",
        desc: "LNGアドバイザリーサービスで、複雑なグローバルLNG市場をナビゲート。長期供給契約からスポットカーゴ調達まで、コスト、セキュリティ、柔軟性のバランスを取ったLNGポートフォリオを最適化します。",
        features: [
          "長期契約の構築",
          "スポット・短期カーゴ調達",
          "価格算定式の最適化",
          "目的地柔軟性の交渉",
          "再ガス化ターミナルアドバイザリー",
        ],
      },
      market: {
        title: "市場分析・価格予測",
        desc: "Medigreen独自の分析フレームワークで実用的な市場インテリジェンスを提供。グローバル需給ダイナミクス、地政学的動向、マクロ経済要因を監視し、正確な価格予測と調達タイミングの推奨を行います。",
        features: [
          "週次・月次市場レポート",
          "価格シナリオモデリング",
          "供給混乱リスク評価",
          "需要見通し分析",
          "競合調達ベンチマーク",
        ],
      },
      contract: {
        title: "契約交渉サポート",
        desc: "経験豊富な交渉者がお客様のチームと共に有利な契約条件を確保。業界標準の契約構造、価格メカニズム、リスク配分フレームワークに関する深い知識を持っています。",
        features: [
          "タームシートのレビュー・作成",
          "価格見直し条項の交渉",
          "不可抗力・責任条項",
          "紛争解決メカニズム",
          "規制対応レビュー",
        ],
      },
      risk: {
        title: "サプライチェーンリスク管理",
        desc: "エネルギー調達ポートフォリオ全体のサプライチェーンリスクの特定、評価、軽減を支援。リスク管理フレームワークで、変動市場条件下でもビジネス継続性を確保します。",
        features: [
          "供給セキュリティ評価",
          "取引先信用リスク分析",
          "地政学的リスク監視",
          "緊急供給計画",
          "保険・ヘッジアドバイザリー",
        ],
      },
      regulatory: {
        title: "規制・コンプライアンスアドバイザリー",
        desc: "国際エネルギー取引の複雑な規制環境をナビゲートするには専門知識が必要です。Medigreenは輸出入規制、制裁対応、環境基準に関するガイダンスを提供します。",
        features: [
          "輸出入規制ガイダンス",
          "制裁対応スクリーニング",
          "環境基準アドバイザリー",
          "カーボンフットプリント評価",
          "政府連携サポート",
        ],
      },
    },
    cta: {
      title: "始める準備はできましたか？",
      description: "本日無料の初回コンサルテーションのためにお問い合わせください。Medigreenがエネルギー調達戦略をどのように変革できるかご確認ください。",
      button: "お問い合わせ",
    },
  },
  about: {
    hero: {
      subtitle: "私たちについて",
      title: "Medigreen LLCについて",
      description: "専門知識、誠実さ、そしてクライアント成果への揺るぎない焦点に基づいて構築された専門エネルギー調達アドバイザリーファーム。",
    },
    story: {
      subtitle: "ストーリー",
      title: "深い業界専門知識に基づいて設立",
      paragraphs: [
        "Medigreen LLCは、エネルギー市場の重要なギャップを埋めるために設立されました。複雑な原油・LNG調達の世界をナビゲートするエネルギー購入者に対し、真に独立した専門アドバイザリーサービスの必要性です。",
        "当社を際立たせるのは、業界ネットワークの広さと深さです。世界中の生産者、トレーダー、金融機関、規制当局との長年の関わりを通じて構築されたネットワークにより、クライアントは従来のチャネルでは得られない機会とインサイトに直接アクセスできます。",
        "この広範なネットワークを活用することで、Medigreenはアドバイスを超えたサービスを提供します。ドアを開き、紹介を促進し、成果を生み出します。日本・韓国から東南アジア、中東まで、当社のネットワークは変動の激しいエネルギー市場におけるあなたの競争優位性です。",
      ],
      cta: "お問い合わせ",
    },
    values: {
      subtitle: "価値観",
      title: "私たちを動かすもの",
      items: {
        integrity: { title: "誠実さ", desc: "完全な透明性を持って事業を行い、常にクライアントの最善の利益のために行動します。" },
        expertise: { title: "専門性", desc: "グローバルエネルギー市場における深い市場知識と数十年の実務経験。" },
        global: { title: "グローバルリーチ", desc: "世界中のサプライヤー、トレーダー、取引先との確立された関係。" },
        results: { title: "成果重視", desc: "クライアントの収益に対して提供する具体的な価値によって成功を測定します。" },
      },
    },
    company: {
      subtitle: "会社情報",
      title: "オフィス",
      address: "住所",
      phone: "電話",
      email: "メール",
    },
    team: {
      subtitle: "チーム",
      title: "チーム紹介",
      members: {
        yasunori: {
          name: "Yasunori Kawauchi",
          title: "創業者兼CEO",
          bio: "グローバルエネルギー生産者、トレーダー、金融機関を横断する広範なネットワークを持つ熟練したリーダー。Yasunoriはmedigreenの戦略的ビジョンと世界中のクライアント関係を主導しています。",
        },
        kevin: {
          name: "Kevin Yamazaki",
          title: "創業者兼CTO",
          bio: "Kevinはデジタルインフラストラクチャとデータ駆動型市場インテリジェンスにおける深い専門知識をもたらし、Medigreenがエネルギー調達のための最先端の分析ツールと技術ソリューションを提供できるようにしています。",
        },
      },
    },
  },
  contact: {
    hero: {
      subtitle: "お問い合わせ",
      title: "お問い合わせ",
      description: "エネルギー調達の最適化をお考えですか？無料の初回コンサルテーションにお問い合わせください。",
    },
    info: {
      subtitle: "オフィス",
      title: "お気軽にご連絡ください",
      description: "専門調達アドバイザリーサポートを求めるエネルギー購入者、電力会社、産業企業からのお問い合わせを歓迎します。",
      items: {
        address: "住所",
        phone: "電話",
        email: "メール",
        hours: "営業時間",
      },
      hoursValue: "月〜金: 午前9時〜午後6時（チャモロ標準時）",
    },
    form: {
      title: "メッセージを送信",
      name: "氏名 *",
      namePlaceholder: "山田 太郎",
      email: "メールアドレス *",
      emailPlaceholder: "taro@company.com",
      company: "会社名",
      companyPlaceholder: "株式会社〇〇",
      subject: "件名",
      subjectOptions: [
        { value: "", label: "トピックを選択..." },
        { value: "Crude Oil Procurement", label: "原油調達" },
        { value: "LNG Procurement", label: "LNG調達" },
        { value: "Market Analysis", label: "市場分析" },
        { value: "Contract Negotiation", label: "契約交渉" },
        { value: "General Inquiry", label: "一般お問い合わせ" },
      ],
      message: "メッセージ *",
      messagePlaceholder: "エネルギー調達のニーズについてお聞かせください...",
      charCount: "{count}/500",
      charError: "メッセージは500文字以内で入力してください。",
      submit: "送信",
      sending: "送信中...",
      error: "エラーが発生しました。もう一度お試しください。",
      success: {
        title: "送信完了！",
        description: "お問い合わせありがとうございます。1営業日以内にご連絡いたします。",
      },
    },
  },
  news: {
    hero: {
      subtitle: "最新情報",
      title: "ニュース・インサイト",
      description: "Medigreenチームからの市場インテリジェンス、業界分析、会社アップデート。",
    },
    articles: {
      readMore: "続きを読む",
    },
  },
  caseStudies: {
    hero: {
      subtitle: "実績",
      title: "ケーススタディ",
      description: "実際のクライアントへの実際の成果。Medigreenがエネルギー調達案件で測定可能な価値を提供した事例をご覧ください。",
    },
    cta: {
      title: "次の成功事例になりませんか",
      description: "Medigreenがエネルギー調達戦略で測定可能な成果を達成するお手伝いをします。",
      button: "お問い合わせ",
    },
  },
  notFound: {
    title: "ページが見つかりません",
    description: "お探しのページは存在しないか、移動しました。",
    button: "ホームに戻る",
  },
  privacy: {
    hero: {
      subtitle: "法的情報",
      title: "プライバシーポリシー",
      updated: "最終更新日：2026年4月3日",
    },
    sections: [
      {
        title: "1. はじめに",
        content: "Medigreen LLC（以下「当社」）は、お客様の個人情報の保護に努めています。本プライバシーポリシーは、当社ウェブサイトへのアクセスやアドバイザリーサービスのご利用に際して、当社がどのように情報を収集・利用・開示・保護するかを説明するものです。",
      },
      {
        title: "2. 収集する情報",
        content: "当社は、お問い合わせフォームへの入力、コンサルテーションのご依頼、またはメールによるご連絡の際に、お客様が任意で提供される個人情報を収集することがあります。収集する情報には、氏名、メールアドレス、会社名、電話番号、エネルギー調達に関するご要望などが含まれます。",
      },
      {
        title: "3. 情報の利用目的",
        content: "収集した情報は、お問い合わせへの対応およびアドバイザリーサービスの提供、市場インサイトや最新情報のお届け（ご同意いただいた場合）、ウェブサイトおよびサービスの改善、適用法令の遵守、ならびに当社の権利・利益の保護のために利用します。",
      },
      {
        title: "4. 情報の共有",
        content: "当社は、お客様の同意なく個人情報を第三者に販売・譲渡・提供することはありません。ただし、サービス提供に必要な場合、法的義務の履行が必要な場合、または当社の権利保護のために必要な場合はこの限りではありません。",
      },
      {
        title: "5. データセキュリティ",
        content: "当社は、個人情報への不正アクセス・改ざん・開示・破壊を防ぐため、適切な技術的・組織的措置を講じています。ただし、インターネット上のデータ送信は完全に安全とは言えず、絶対的なセキュリティを保証することはできません。",
      },
      {
        title: "6. クッキー",
        content: "当社ウェブサイトでは、閲覧体験の向上のためにクッキーおよび類似の追跡技術を使用することがあります。ブラウザの設定でクッキーを拒否することも可能ですが、一部の機能が正常に動作しない場合があります。",
      },
      {
        title: "7. 外部リンク",
        content: "当社ウェブサイトには第三者のウェブサイトへのリンクが含まれる場合があります。当社はそれらのサイトのプライバシー慣行やコンテンツについて責任を負いません。訪問先のサイトのプライバシーポリシーをご確認ください。",
      },
      {
        title: "8. お客様の権利",
        content: "お客様の所在地によっては、個人情報へのアクセス・訂正・削除などの権利が認められる場合があります。これらの権利を行使される場合は、info@medigreen.energy までご連絡ください。",
      },
      {
        title: "9. ポリシーの変更",
        content: "当社は本プライバシーポリシーを随時更新することがあります。変更がある場合は、更新日とともに本ページに掲載します。変更後も当社ウェブサイトをご利用いただくことで、新しいポリシーへの同意とみなします。",
      },
      {
        title: "10. お問い合わせ",
        content: "本プライバシーポリシーに関するご質問は、下記までお問い合わせください。Medigreen LLC、1411 Pale San Vitores Road, Suite 303, Tamuning, GU | メール：info@medigreen.energy | 電話：+1.671.482.0104",
      },
    ],
  },
  terms: {
    hero: {
      subtitle: "法的情報",
      title: "利用規約",
      updated: "最終更新日：2026年4月3日",
    },
    sections: [
      {
        title: "1. 規約への同意",
        content: "Medigreen LLCのウェブサイト（以下「本サイト」）にアクセスし利用することで、お客様は本利用規約に同意したものとみなされます。同意いただけない場合は、本サイトのご利用をお控えください。",
      },
      {
        title: "2. サイトの利用",
        content: "本サイトは合法的な目的にのみご利用いただけます。適用法令に違反する行為、有害または不適切なコンテンツの送信、本サイトへの不正アクセスの試み、または本サイトの正常な機能を妨害する行為は禁止されています。",
      },
      {
        title: "3. 知的財産権",
        content: "本サイト上のすべてのコンテンツ（テキスト、グラフィック、ロゴ、画像を含む）はMedigreen LLCの財産であり、適用される知的財産法によって保護されています。当社の書面による明示的な許可なく、複製・配布・二次的著作物の作成を行うことはできません。",
      },
      {
        title: "4. アドバイザリーサービスの免責事項",
        content: "本サイトに掲載されている情報は一般的な情報提供を目的としたものであり、専門的なアドバイス、法的アドバイス、または財務アドバイスを構成するものではありません。Medigreen LLCのアドバイザリーサービスのご利用は、別途書面による契約に基づきます。過去の実績は将来の結果を保証するものではありません。",
      },
      {
        title: "5. 責任の制限",
        content: "法律で認められる最大限の範囲において、Medigreen LLCは、本サイトのご利用または掲載情報への依拠から生じる間接的・付随的・特別・結果的・懲罰的損害について責任を負いません。",
      },
      {
        title: "6. 機密保持",
        content: "本サイトを通じてご提出いただいた情報（お問い合わせやコンサルテーションのご依頼を含む）は、厳格な機密として取り扱います。法律で義務付けられている場合を除き、お客様の同意なく第三者に開示することはありません。",
      },
      {
        title: "7. 外部リンク",
        content: "本サイトには、利便性のために第三者のウェブサイトへのリンクが含まれる場合があります。Medigreen LLCは、第三者サイトのコンテンツ、プライバシーポリシー、または慣行について推奨または責任を負いません。",
      },
      {
        title: "8. 規約の変更",
        content: "Medigreen LLCは、本利用規約をいつでも変更する権利を留保します。変更は本サイトへの掲載後、直ちに効力を生じます。変更後も本サイトをご利用いただくことで、改訂された規約への同意とみなします。",
      },
      {
        title: "9. 準拠法",
        content: "本利用規約は、グアム（米国）の法律に準拠し、その法律に従って解釈されます。",
      },
      {
        title: "10. お問い合わせ",
        content: "本利用規約に関するご質問は、下記までお問い合わせください。Medigreen LLC、1411 Pale San Vitores Road, Suite 303, Tamuning, GU | メール：info@medigreen.energy | 電話：+1.671.482.0104",
      },
    ],
  },
};

export default pages;